const ACCOUNTABLE_TYPES = ["physicals", "legals", "professionals", "managers"];

const isAValidAccountable = obj =>
  obj && obj.id && ACCOUNTABLE_TYPES.includes(obj.type);

export default {
  isAValidAccountable
};



// WEBPACK FOOTER //
// ./src/API/helpers/JSONAPI.js